<template>
  <div>
    <v-card>
      <v-card-title>
        <h3 class="mx-auto">{{ this.$tc("commons.changedPass") }}</h3>
      </v-card-title>
      <v-alert
        class="mb-2"
        type="error"
        v-if="alertError"
        style="display: flex; justify-content: center; margin: 0 40px"
      >
        {{ alertValidate }}
      </v-alert>
      <v-form ref="form" v-model="valid">
        <v-row class="justify-center mt-2">
          <v-text-field
            outlined
            :label="$tc('login.user')"
            prepend-inner-icon="fa-user"
            color="primary"
            v-model="email"
            required
            dense
            full-width
            style="max-width: 400px"
            :rules="emailRules"
            readonly
          />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                class="ml-2"
                v-bind="attrs"
                v-on="on"
                :disabled="checkEmail(email)"
                @click="copyContend(email)"
              >
                <v-icon>fas fa-copy</v-icon>
              </v-btn>
            </template>
            <span>{{
              this.success
                ? this.$tc("commons.copySuccess")
                : this.$tc("commons.copy")
            }}</span>
          </v-tooltip>
        </v-row>
        <v-row class="justify-center mt-2">
          <v-text-field
            outlined
            :label="$tc('login.password')"
            prepend-inner-icon="fa-lock"
            v-model="password"
            color="primary"
            dense
            @keyup.enter="signIn()"
            :type="show ? 'text' : 'password'"
            :append-icon="show ? 'fa-eye' : 'fa-eye-slash'"
            @click:append="show = !show"
            required
            full-width
            style="max-width: 355px"
            :rules="passwordRules"
          />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="generatePassword"
                icon
                class="mx-2"
                v-bind="attrs"
                v-on="on"
                :disabled="!checkPass(password)"
              >
                <v-icon>fas fa-sync-alt</v-icon>
              </v-btn>
            </template>
            <span>{{ $tc("commons.generate") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="copyContend(password)"
                icon
                v-bind="attrs"
                v-on="on"
                :disabled="checkPass(password)"
              >
                <v-icon>fas fa-copy</v-icon>
              </v-btn>
            </template>
            <span>{{
              this.success
                ? this.$tc("commons.copySuccess")
                : $tc("commons.copy")
            }}</span>
          </v-tooltip>
        </v-row>
      </v-form>
      <v-card-actions class="d-flex justify-space-around py-5">
        <v-btn class="bt-exit" @click="cancelChanged">{{
          $tc("commons.cancel")
        }}</v-btn>
        <v-btn class="bt-acept" text @click="isValid">{{
          $tc("commons.accept")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import operators from "../../../../store/operadores/operators";
export default {
  data() {
    return {
      email: "",
      password: "",
      show: false,
      valid: true,
      alertError: false,
      alertValidate: "",
      success: false,
      id: null,
      emailRules: [
        (v) => !!v || this.$tc("login.userRequired"),
        (v) => (v && v.length > 2) || this.$tc("login.userRules"),
      ],
      passwordRules: [
        (value) => !!value || this.$tc("login.passRequired"),
        (value) =>
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/.test(value) ||
          this.$tc("login.mustContainPass"),
        (value) =>
          /[!@#$%^&*(),.?":{}|<>=/+\-_]/.test(value) ||
          this.$tc("login.mustContainSpecial"),
        (value) =>
          (value && value.length >= 8) || this.$tc("login.mustLengthPass"),
      ],
    };
  },
  mounted() {
    this.email = this.user;
    this.id = this.idOper;
  },
  methods: {
    async generatePassword() {
      this.password = await operators.dispatch("getGeneratePassword");
    },
    checkEmail(email) {
      let boolean;
      if (email !== "") {
        boolean = false;
      } else {
        boolean = true;
      }
      return boolean;
    },
    checkPass(pass) {
      let boolean;
      if (pass !== "") {
        boolean = false;
      } else {
        boolean = true;
      }
      return boolean;
    },
    copyContend(userText) {
      if (userText && userText.trim() !== "") {
        navigator.clipboard
          .writeText(userText)
          .then(() => {
            this.success = !this.success;
            setTimeout(() => {
              this.success = !this.success;
            }, 1000);
          })
          .catch((err) => {
            console.error("Error copying text: ", err);
          });
      }
    },
    validUser() {
      return this.email !== "";
    },
    isValid() {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.$emit("confirmChanged", this.id, this.password);
        this.email = "";
        this.password = "";
        this.id = null;
      } else {
        this.alertError = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.alertError = false;
        }, 2500);
      }
    },
    cancelChanged() {
      this.$emit("cancelChanged");
      this.email = "";
      this.password = "";
      this.id = null;
    },
  },
  props: {
    user: {
      type: String,
    },
    idOper: {
      type: Number,
    },
  },
};
</script>

<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
